import { Routes } from '@angular/router';

import { SupportGuardService } from './services/support-guard.service';
import { NewsGuardService } from './services/news-guard.service';

import { PageHomeComponent } from './routes/home/home.component';
import { PageFootballComponent } from './routes/football/football.component';
import { PageFitnessComponent } from './routes/fitness/fitness.component';
import { PageSoccerComponent } from './routes/soccer/soccer.component';
import { PageVRComponent } from './routes/vr/vr.component';
import { PageSupportComponent } from './routes/support/support.component';
import { PageSupportFootballComponent } from './routes/support-football/support-football.component';
import { PageSupportSoccerComponent } from './routes/support-soccer/support-soccer.component';
import { PageSupportFitnessComponent } from './routes/support-fitness/support-fitness.component';
import { PagePressComponent } from './routes/press/press.component';
import { PagePrivacyPolicyComponent } from './routes/privacy-policy/privacy-policy.component';
import { PageTermsOfUseComponent } from './routes/terms-of-use/terms-of-use.component';
import { PageEulaComponent } from './routes/eula/eula.component';
import { PageAccountsComponent } from './routes/page-accounts/page-accounts.component';
import { PageNotFoundComponent } from './routes/not-found/not-found.component';
import { PageNewsComponent } from './routes/news/news.component';
import { PageNewsSingleComponent } from './routes/news-single/news-single.component';
import { PageShareUnknownFootballComponent } from './routes/share-unknown-football/share-unknown-football.component';
import { PageShareUnknownSoccerComponent } from './routes/share-unknown-soccer/share-unknown-soccer.component';

import { PageShareAppleFootballComponent } from './routes/share-apple-football/share-apple-football.component';
import { PageShareAppleSoccerComponent } from './routes/share-apple-soccer/share-apple-soccer.component';
import { PageShareAndroidFootballComponent } from './routes/share-android-football/share-android-football.component';
import { PageShareAndroidSoccerComponent } from './routes/share-android-soccer/share-android-soccer.component';

export const routes: Routes = [
  { path: '', component: PageHomeComponent },
  {
    path: 'football',
    component: PageFootballComponent,
    data: { title: 'Football' }
  },
  {
    path: 'fitness',
    component: PageFitnessComponent,
    data: { title: 'Fitness' }
  },
  { path: 'soccer', component: PageSoccerComponent, data: { title: 'Soccer' } },
  {
    path: 'vr',
    component: PageVRComponent,
    data: { title: 'VR' }
  },
  {
    path: 'support',
    component: PageSupportComponent,
    canActivate: [SupportGuardService],
    data: { title: 'Support' }
  },
  {
    path: 'support/football',
    component: PageSupportFootballComponent,
    data: { title: 'Football Support' }
  },
  {
    path: 'support/soccer',
    component: PageSupportSoccerComponent,
    data: { title: 'Soccer Support' }
  },
  {
    path: 'support/fitness',
    component: PageSupportFitnessComponent,
    data: { title: 'Fitness Support' }
  },
  { path: 'press', component: PagePressComponent, data: { title: 'Press' } },
  {
    path: 'privacy-policy',
    component: PagePrivacyPolicyComponent,
    data: { title: 'Privacy Policy' }
  },
  {
    path: 'terms-of-use',
    component: PageTermsOfUseComponent,
    data: { title: 'Terms Of Use' }
  },
  { path: 'eula', component: PageEulaComponent, data: { title: 'EULA' } },
  {
    path: ':sport/account/password',
    component: PageAccountsComponent,
    data: { title: 'Change Password' }
  },
  {
    path: ':sport/account/verify',
    component: PageAccountsComponent,
    data: { title: 'Verify Account' }
  },
  {
    path: ':sport/account/verify-user',
    component: PageAccountsComponent,
    data: { title: 'Verify User Account' }
  },
  {
    path: ':sport/account/password-reset',
    component: PageAccountsComponent,
    data: { title: 'New Password Reset' }
  },
  {
    path: ':sport/account/verify-password-reset',
    component: PageAccountsComponent,
    data: { title: 'New Password Verify Reset' }
  },
  {
    path: ':sport/account/cancel-password-reset',
    component: PageAccountsComponent,
    data: { title: 'New Password Cancel Reset' }
  },
  {
    path: ':sport/account/verify-email-change',
    component: PageAccountsComponent,
    data: { title: 'New Verify Email Change' }
  },
  {
    path: ':sport/account/submit-email-change',
    component: PageAccountsComponent,
    data: { title: 'New Submit Email Change' }
  },
  {
    path: ':sport/account/cancel-email-change',
    component: PageAccountsComponent,
    data: { title: 'New Cancel Email Change' }
  },
  {
    path: ':sport/account/revoke-email-change',
    component: PageAccountsComponent,
    data: { title: 'New Revoke Email Change' }
  },
  {
    path: ':sport/account/void-email-change',
    component: PageAccountsComponent,
    data: { title: 'New Void Email Change' }
  },
  {
    path: ':sport/account/password-change',
    component: PageAccountsComponent,
    data: { title: 'New Password Change' }
  },
  {
    path: ':sport/account/verify-password-change',
    component: PageAccountsComponent,
    data: { title: 'New Verify Password Change' }
  },
  {
    path: ':sport/account/cancel-password-change',
    component: PageAccountsComponent,
    data: { title: 'New Cancel Password Change' }
  },
  {
    path: ':sport/account/create-user',
    component: PageAccountsComponent,
    data: { title: 'Create Account' }
  },
  {
    path: ':sport/account/email',
    component: PageAccountsComponent,
    data: { title: 'Update Email' }
  },
  {
    path: ':sport/account/cancelEmail',
    component: PageAccountsComponent,
    data: { title: 'Cancel Email Update' }
  },
  {
    path: ':sport/account/unlock',
    component: PageAccountsComponent,
    data: { title: 'Unlock Account' }
  },
  {
    path: ':sport/account/resend',
    component: PageAccountsComponent,
    data: { title: 'Resend Verification' }
  },
  {
    path: 'news',
    component: PageNewsComponent
  },
  {
    path: 'news/article/:id',
    component: PageNewsSingleComponent,
    canActivate: [NewsGuardService]
  },
  {
    path: 'news/article',
    redirectTo: 'news'
  },
  {
    path: 'share/unknown/football',
    component: PageShareUnknownFootballComponent,
    data: { title: 'Share GoArmyEdge Football' }
  },
  {
    path: 'share/unknown/soccer',
    component: PageShareUnknownSoccerComponent,
    data: { title: 'Share GoArmyEdge Soccer' }
  },
  {
    path: 'share/apple/football',
    component: PageShareAppleFootballComponent,
    data: { title: 'Share GoArmyEdge Football' }
  },
  {
    path: 'share/apple/soccer',
    component: PageShareAppleSoccerComponent,
    data: { title: 'Share GoArmyEdge Soccer' }
  },
  {
    path: 'share/android/football',
    component: PageShareAndroidFootballComponent,
    data: { title: 'Share GoArmyEdge Football' }
  },
  {
    path: 'share/android/soccer',
    component: PageShareAndroidSoccerComponent,
    data: { title: 'Share GoArmyEdge Soccer' }
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: { title: 'Page Not Found' }
  }
];
